import { useCallback } from 'react';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ApplicationSummary } from '../../../shared/VolunteerApplicationServiceTypes';

const { Text } = Typography;

interface CTDApplicationSummaryCardProps extends ApplicationSummary {
	onEvaluateClick: (application: ApplicationSummary) => void;
}

export const CTDApplicationSummaryCard = (
	props: CTDApplicationSummaryCardProps
) => {
	const {
		applicant: { firstName, lastName, srcmid, gender },
		center,
		onEvaluateClick,
	} = props;
	const { t } = useTranslation();
	const handleViewClick = useCallback(() => {
		onEvaluateClick(props);
	}, [onEvaluateClick, props]);

	return (
		<>
			<div className="flex flex-col rounded-lg border border-solid border-gray-300 bg-[rgba(232,232,233,0.4)] p-[16px] py-[24px]">
				<div className="flex flex-row gap-6 mb-4">
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('fullName')}</Text>
						<Text className="text-gray-650 text-sm font-bold">{`${
							firstName ?? ''
						} ${lastName ?? ''}`}</Text>
					</div>
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('gender')}</Text>
						<Text className="text-gray-650 text-sm font-bold">
							{gender &&
								gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase()}
						</Text>
					</div>
				</div>
				<div className="flex flex-row gap-6 mb-4">
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('idCardNo')}</Text>
						<Text className="text-gray-650 text-sm font-bold">{srcmid}</Text>
					</div>
					<div className="flex flex-col gap-1 w-[50%]">
						<Text className="text-light-gray text-sm">{t('zone')}</Text>
						<Text className="text-gray-650 text-sm font-bold">
							{center.zone}
						</Text>
					</div>
				</div>
				<div className="flex justify-center">
					<Button
						onClick={handleViewClick}
						className="w-full font-bold text-primary-blue border border-solid border-primary-blue"
					>
						{t('view')}
					</Button>
				</div>
			</div>
		</>
	);
};
